import clsx from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { formattedArea } from "react-migration/lib/util/measurements";
import { getMeasurementSystemPreference } from "src/js/stores/user/actions/getSetting";

export interface CompsCalculatorErrorMessageProps {
  className?: string;
  drawing?: unknown;
}

export function ComparablesCalculatorErrorMessage({ className, drawing }: Readonly<CompsCalculatorErrorMessageProps>) {
  const unitPreference = getMeasurementSystemPreference();
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        "flex p-2 bg-negative-50 border-border-action-destructive-hover rounded-lg text-background-surface-destructive-accent text-xs",
        className
      )}
    >
      {t(
        drawing
          ? "comparables.calculator.hometrack_search_shape_too_large"
          : "comparables.calculator.hometrack_search_viewport_too_large"
      )}{" "}
      {formattedArea({ area: 30000000, unitPreference, t, granularity: "large" })},{" "}
      {t(drawing ? "comparables.calculator.revise_selection" : "comparables.calculator.zoom_or_draw")}
    </div>
  );
}
